module.exports = {
          srcSet: __webpack_public_path__ + "b6dff366.jpg"+" 45w",
          images:[ {path: __webpack_public_path__ + "b6dff366.jpg",width: 45,height: 45}],
          src: __webpack_public_path__ + "b6dff366.jpg",
          toString:function(){return __webpack_public_path__ + "b6dff366.jpg"},
          
          width: 45,
          height: 45
        }